import { Component, Input } from '@angular/core';
import { CmsComponentData } from "@spartacus/storefront";
import { CmsLinkComponent, CmsService, isNotUndefined } from "@spartacus/core";
import { filter, map, switchMap } from "rxjs/operators";
import { combineLatest, Observable } from "rxjs";
import { CustomLinkListData } from "./custom-link-list.model";

@Component({
  selector: 'app-custom-link-list',
  templateUrl: './custom-link-list.component.html',
  standalone: false
})
export class CustomLinkListComponent {

  private readonly componentType = 'LinkListComponent';

  @Input() item: CustomLinkListData;

  constructor(
    private componentData: CmsComponentData<CustomLinkListData>,
    private cmsService: CmsService
  ) {}

  data$: Observable<CustomLinkListData> = this.componentData.data$.pipe(
    filter(isNotUndefined),
    map((component) => {
      let componentData: CustomLinkListData = {};

      if (component.typeCode === this.componentType) {
        componentData = { ...component };
      }

      return { ...componentData, ...this.item };
    }));

  items$: Observable<CmsLinkComponent[]> = this.data$.pipe(
    filter(isNotUndefined),
    switchMap(data =>
      combineLatest(
        data.items?.trim().split(' ').map((codes: any) => this.cmsService.getComponentData(codes).pipe(
          map(tab => tab)
        )))
    ));
}
